import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { LEFTBAR_GENERAL_ROW_CONTACT_CENTER_COLORS as t, LEFTBAR_GENERAL_ROW_TYPES as n } from "./general-row-constants.js";
import { createBlock as r, createCommentVNode as i, createElementBlock as a, createVNode as o, normalizeClass as s, openBlock as c, resolveComponent as l, resolveDynamicComponent as u } from "vue";
import { DtIconAtSign as d, DtIconCalendarClock as f, DtIconContacts as p, DtIconDialbot as m, DtIconExternalLink as h, DtIconHash as g, DtIconHashBold as _, DtIconInbox as v, DtIconLaptop2 as y, DtIconLayoutTemplate as b, DtIconLock as x, DtIconLockFilled as S, DtIconSparkle as C, DtIconThread as w, DtIconUsers as T } from "@dialpad/dialtone-icons/vue";
//#region recipes/leftbar/general_row/leftbar_general_row_icon.vue
var E = new Map([
	[n.INBOX, v],
	[n.CONTACTS, p],
	[n.CHANNELS, g],
	[n.THREADS, w],
	[n.LAUNCHPAD, b],
	[n.LOCKED_CHANNEL, x],
	[n.QUICK_START, C],
	[n.COACHING_GROUP, T],
	[n.COACHING_CENTER, h],
	["locked channel unread", S],
	["channel unread", _],
	[n.ASSIGNED, d],
	[n.DIGITAL, y],
	[n.SCHEDULED, f]
]), D = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeLeftbarGeneralRowIcon",
	components: {
		DtIconDialbot: m,
		DtIconInbox: v,
		DtIconContacts: p,
		DtIconHash: g,
		DtIconThread: w,
		DtIconLayoutTemplate: b,
		DtIconLock: x,
		DtIconSparkle: C,
		DtIconUsers: T,
		DtIconExternalLink: h,
		DtIconLockFilled: S,
		DtIconHashBold: _,
		DtIconAtSign: d,
		DtIconLaptop2: y,
		DtIconCalendarClock: f
	},
	props: {
		type: {
			type: String,
			default: null
		},
		color: {
			type: String,
			default: null
		},
		iconSize: {
			type: String,
			default: "300"
		}
	},
	computed: {
		isIconType() {
			return ![n.DIALBOT, n.CONTACT_CENTER].includes(this.type);
		},
		isContactCenterType() {
			return this.type === n.CONTACT_CENTER;
		},
		isDialbotType() {
			return this.type === n.DIALBOT;
		},
		getIconName() {
			return E.get(this.type);
		},
		contactCenterIconClasses() {
			return ["d-recipe-leftbar-row__icon-cc", t[this.color]];
		}
	}
}, O = {
	key: 2,
	class: "d-recipe-leftbar-general-row__icon",
	"data-qa": "general-row-dialbot"
};
function k(e, t, n, d, f, p) {
	let m = l("dt-icon-dialbot");
	return p.isIconType ? (c(), r(u(p.getIconName), {
		key: 0,
		size: n.iconSize
	}, null, 8, ["size"])) : p.isContactCenterType ? (c(), a("div", {
		key: 1,
		class: s(p.contactCenterIconClasses)
	}, null, 2)) : p.isDialbotType ? (c(), a("div", O, [o(m, { size: "500" })])) : i("", !0);
}
var A = /* @__PURE__ */ e(D, [["render", k]]);
//#endregion
export { A as default };

//# sourceMappingURL=leftbar-general-row-icon.js.map